import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router';
import { BgLogin, Logo } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

declare var window: any;

class Success extends React.Component<Props> {

	componentDidMount() {
		if (this.props.user) {
			this.props.history.replace('/');
		}

		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Inicio',
				onBack: null
			}
		});
	}
	
	render() {
		return (
			<div id="login">
				<div className="container-black">
					<div className="row container-form container-bg" style={{ backgroundColor: `white`, padding: '20px', borderRadius: '10px' }}>
						<div className="text-center">
							<img src={ Logo } className="logo-password" />
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect()(Success);